
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: [
    'title',
    'subtitle',
    'linkText',
    'link',
    'videoId',
    'videoControls',
    'videoAutoplay',
    'videoLoop',
    'videoMute',
  ],
  setup() {
    return {}
  },
})
